import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { TabsContext } from '../../../packages/kiti/components/tabs/TabsContext'
import { tabsOptions as baseTabsOptions } from './tabs/_data/tabsOptions'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'
import ServiceOrderLoader from './_load/ServiceOrderLoader'
import TabsContent from '../../../packages/kiti/components/tabs/TabsContent'
import ServiceOrderContextEvents from './ServiceOrderContextEvents'

const ShowServiceOrderModal = props => {
  const { t } = useTranslation('serviceOrders')

  const canSeeTimeline = useSessionPermission('seeServiceOrdersTimeline')
  const canSeeTriggerEvents = useSessionPermission('seeServiceOrdersTriggerEvents')
  const canSeeAuditPanel = useSessionPermission('seeServiceOrdersAuditPanel')

  const notShowByTranslationKey = {
    timeline: !canSeeTimeline,
    triggerEvents: !canSeeTriggerEvents,
    audit: !canSeeAuditPanel
  }

  const tabsOptions = baseTabsOptions.map(option => ({
    ...option,
    name: t(`tabs.${option.translationKey}`),
    notShow: notShowByTranslationKey[option.translationKey]
  }))

  return (
    <ControlledModal width="62rem" {...props}>
      <ServiceOrderContextEvents>
        <ServiceOrderLoader>
          <TabsContext options={tabsOptions}>
            <ModalHeader />
            <HorizontalLine thin lineColor={COLORS.light2} />
            <Separator weight={6} />
            <TabsContent />
          </TabsContext>
        </ServiceOrderLoader>
      </ServiceOrderContextEvents>
    </ControlledModal>
  )
}

export default ShowServiceOrderModal
